import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SingleAemEspot from '../../SingleAemEspot';
import legacyStyleSupport from '../../SmallScreenNavCategories/SmallScreenNavCategories.module.scss';
import styles from './menu.module.scss';

/**
 * MenuGroup component is wrapper around MenuList, providing the heading and top espot.
 *
 * @param {React.ReactNode} props.children - Usually a MenuList
 * @param {string} [props.heading] - Optional heading text for the group.
 * @param {string} [props.headingKey=''] - TMNT key for the heading
 * @param {string} [props.label=''] - Aria label for the group.
 * @param {string} [props.topEspotIdentifier] - ID of the top espot, if any.
 * @param {React.ReactNode} [props.preEspotContent=null] - Usually the "all" link.
 * @returns {JSX.Element} The rendered MenuGroup component.
 */

const MenuGroup = ({
  children, heading, headingKey = '', label = '', topEspotIdentifier, preEspotContent = null,
}) => (
  <div
    aria-label={label}
    className={classNames(styles.container, legacyStyleSupport.categoryListItem)}
  >
    {heading ? (
      <h2 className={styles.heading} data-property={headingKey} data-testid="nav-category-heading">{heading}</h2>
    ) : null}
    {preEspotContent}
    {topEspotIdentifier ? (
      <div className={classNames('accordion', styles.espot)}><SingleAemEspot espotId={topEspotIdentifier} /></div>
    ) : null}
    <div className={styles.group}>{children}</div>
  </div>
);

MenuGroup.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  headingKey: PropTypes.string,
  label: PropTypes.string,
  preEspotContent: PropTypes.node,
  topEspotIdentifier: PropTypes.string,
};

export default MenuGroup;
